<template>
  <a
    class="cta-button v-btn v-btn--depressed theme--light v-size--default"
    :href="fileLocation"
    :download="fileName"
  >
    <span class="v-btn__content">
      <v-icon left>mdi-cloud-download</v-icon> {{ text }}
    </span>
  </a>
</template>
<script>
export default {
  data() {
    return {
      // ...
    };
  },
  methods: {
    doClick(event) {
      this.$emit("click", event);
    }
  },
  props: ["disabled", "fileLocation", "fileName", "text"]
};
</script>
<style lang="sass" scoped>
.cta-button.v-btn:not(.v-btn--round)
  justify-self: center
  border-radius: 4px
  background-color: $primary !important
  height: 32px

.cta-button.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).theme--light
  background-color: #DCDCDC !important
  ::v-deep .v-btn__content
    color: $lightish-grey !important

.cta-button
  ::v-deep .v-btn__content
    color: white
    font-size: 16px
    font-weight: bold
    line-height: 20px
    text-align: center
    text-transform: none
</style>
